export const enum talentFiltersTrackId {
  verticalList = 'foam-myagency-talentFilters-verticalsList',
  gendersList = 'foam-myagency-talentFilters-gendersList',
  platformsList = 'foam-myagency-talentFilters-platformsList',
  location = 'foam-myagency-talentFilters-location',
  age = 'foam-myagency-talentFilters-age',
}
